import {z} from 'zod'
import api from '../../../transport'
import {setUserToken} from 'features/common/utils/token'
import {HTTPError} from 'ky'

const signinResponseSchema = z.object({
    token: z.string(),
})
const ERROR_STATUS_EMAIL_WRONG_CREDENTIALS = 403

const signin = async (data: {email: string; password: string}) => {
    try {
        const res = await api
            .post('auth/signIn', {body: JSON.stringify(data)})
            .json()

        const parseRes = signinResponseSchema.parse(res)
        setUserToken(parseRes.token)

        return parseRes.token
    } catch (err) {
        if (err instanceof HTTPError) {
            if (err.response.status === ERROR_STATUS_EMAIL_WRONG_CREDENTIALS) {
                throw new Error('ERROR_EMAIL_WRONG_CREDENTIALS')
            }
        }
    }
}

export default signin
